import { AsyncPipe, DatePipe, I18nPluralPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalComponent, SdvorButtonComponent } from '@sdvor/shared/ui';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { TrackingPickupSchemeComponent } from './tracking-pickup-scheme.component';

@NgModule({
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    NgClass,
    I18nPluralPipe,
    DatePipe,
    ModalComponent,
    IconModule,
    SdvorButtonComponent,
    MediaModule,
  ],
  declarations: [TrackingPickupSchemeComponent],
  exports: [TrackingPickupSchemeComponent],
})
export class TrackingPickupSchemeComponentModule {}
